export default "__VITE_ASSET__FjEbfedC__"